import { AdvantagesOurItem } from './advantages-our/advantages-our'
import { ClockIcon } from './advantages-our/assets/clock-icon'
import { LikeIcon } from './advantages-our/assets/like-icon'
import { ShieldIcon } from './advantages-our/assets/shield-icon'
import { ToolsIcon } from './advantages-our/assets/tools-icon'
import { serviceItems } from './service-today/service-today'

export const bannerDesktop = {
	src: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/banner.png',
	alt: 'С заботой о каждом устройстве. Ваш iPort.',
	width: 1920,
	height: 920
}
export const bannerMobile = {
	src: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/banner_mob.png',
	alt: 'С заботой о каждом устройстве. Ваш iPort.',
	width: 920,
	height: 540
}
export const serviceTodayData: serviceItems[] = [
	{
		link: {
			label: 'Розничная сеть',
			href: 'https://www.iport.ru/service/'
		},
		title: 'Провели более 280&nbsp;тыс. ремонтов',
		subtitle: [
			'Ежедневно мы&nbsp;принимаем сотни устройств на&nbsp;ремонт&nbsp;&mdash; от&nbsp;простого до&nbsp;самого сложного.',
			'Строгие регламенты и&nbsp;стандартизация на&nbsp;каждом этапе позволяют нам обеспечивать одинаково высокий уровень качества во&nbsp;всех наших сервисах.'
		],
		image: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/service-today-1.png'
	},
	{
		link: {
			label: 'Корпоративное направление',
			href: 'https://www.iport.ru/service/for-business/'
		},
		title: 'Работа с&nbsp;крупнейшими финтех и&nbsp;фудтех компаниями',
		subtitle: [
			'Решаем задачи любой сложности для современного бизнеса.',
			'Можем работать как по&nbsp;единичным заказам, так и&nbsp;&laquo;на&nbsp;потоке&raquo;&nbsp;&mdash; всё зависит от&nbsp;вас и&nbsp;ваших потребностей.'
		],
		image: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/service-today-2.png'
	},
	{
		link: {
			label: 'Продажа техники Apple',
			href: 'https://www.iport.ru/discount/'
		},
		title: '40&nbsp;000+ проданных&nbsp;устройств',
		subtitle: [
			'Мы&nbsp;делаем технику Apple доступнее&nbsp;&mdash; в&nbsp;наших сервисах можно приобретать устройства, сданные по обмену в Трейд-ин, по&nbsp;привлекательным ценам.',
			'Все гаджеты полностью проверены и&nbsp;готовы к&nbsp;работе.'
		],
		image: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/service-today-3.png'
	}
]
export const advantagesData: AdvantagesOurItem[] = [
	{
		Icon: LikeIcon,
		title: 'Удобство',
		text: 'Сервисы расположены в&nbsp;крупных ТЦ&nbsp;и&nbsp;работают без выходных'
	},
	{
		Icon: ClockIcon,
		title: 'Короткие сроки',
		text: 'В&nbsp;среднем до&nbsp;5&nbsp;дней, для модульных замен доступен экспресс-ремонт в&nbsp;течение дня'
	},
	{
		Icon: ToolsIcon,
		title: 'Любые задачи',
		text: 'Мы&nbsp;берёмся даже&nbsp;за&nbsp;самые сложные случаи'
	},
	{
		Icon: ShieldIcon,
		title: 'С&nbsp;гарантией',
		text: '90&nbsp;дней гарантии на&nbsp;работы и&nbsp;запчасти, выдаем все документы по&nbsp;ремонту'
	}
]
export const faqItems = [
	{
		question: 'Вы&nbsp;официальный сервис Apple?',
		answer:
			'Компания Apple на&nbsp;текущий момент не&nbsp;обслуживает устройства на&nbsp;территории России, но&nbsp;мы&nbsp;продолжаем придерживаться высокого качества обслуживания, как и&nbsp;ранее.'
	},
	{
		question: 'Какие у&nbsp;вас запчасти?',
		answer:
			'Мы&nbsp;используем как оригинальные запчасти, так и&nbsp;качественные аналоги. Вы&nbsp;сами выбираете подходящий для вас вариант.'
	},
	{
		question: 'Почему нужно выбирать вас?',
		answer:
			'Чтобы сдать устройство на&nbsp;ремонт, зная, что можно ни&nbsp;о&nbsp;чём не&nbsp;беспокоиться в&nbsp;процессе и&nbsp;после.<br/> Мы считаем, что высокий уровень качества работ обеспечивается высоким качеством всех его составляющих. Поэтому мы не экономим на оборудовании, запчастях или расходных материалах, а работы проводят специалисты топ-квалификации, которые регулярно обучаются и всегда в курсе самых актуальных методов ремонта устройств Apple. '
	}
]
